import { render, staticRenderFns } from "./ProductZone.vue?vue&type=template&id=60c0e731&scoped=true"
import script from "./ProductZone.vue?vue&type=script&lang=js"
export * from "./ProductZone.vue?vue&type=script&lang=js"
import style0 from "./ProductZone.vue?vue&type=style&index=0&id=60c0e731&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c0e731",
  null
  
)

export default component.exports